module.exports = __webpack_public_path__ + "img/forwardblack.3d6776db.svg";